module.exports = __webpack_public_path__ + "16_hair_black.af3f44a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/16_hair_black.png
// module id = PaTb
// module chunks = 0